import React from 'react'
import { Button, Card, CardBody, Heading, Text } from 'toonswap-uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

function AboutHuntToken() {
  const { t } = useTranslation()

  return (
    <Container>
      <StyledCard>
        <StyledCardBody>
          <CardContent>
            <div>
              <Heading as="h4" size="lg" mb="8px">
                {t('About $TOON token')}
              </Heading>
              <Text as="p" color="textSubtle">
                {t('Overview of $TOON token')}
              </Text>
            </div>
            <Text as="p" color="textSubtle">
              {t(
                "TOON is a next-generation ETH reward token on the Ethereum ecosystem. 4% of every transaction made with the TOON tokens, goes back to holders of TOON in ETH rewards. With the recent boom in DeFi, our goal here at ToonSwap is to make DeFi easy and accessible to everyone. DeFi doesn't have to be difficult, it can be as easy as buying and holding a token to earn passive income.",
              )}
            </Text>
            <Text as="p" color="textSubtle">
              <Text as="p" bold>
                {t('This is how TOON works')}:
              </Text>
              {t(
                'Simply swap your coins for $TOON on Ethereum, and HODL it! You could claim and track your rewards from our dashboard.',
              )}
            </Text>
            <a href="/toon-pad">
              <Button
                style={{
                  width: 'max-content',
                }}
              >
                {t('To buy $TOON, click here')}
              </Button>
            </a>
          </CardContent>
          <StyledImage src="/images/assets/hunt/token-big.svg" alt="" />
        </StyledCardBody>
      </StyledCard>
    </Container>
  )
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 24px;
  font-weight: bold;
  flex-direction: column-reverse;
  gap: 20px;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
  }
`

export const StyledCard = styled(Card)`
  width: 100%;
  border: 1px solid ${({ theme }) => (theme?.isDark ? '#29292D' : '#E5E8EC')};
`
export const StyledCardBody = styled(CardBody)`
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
  }
`
export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.md} {
    width: 50%;
  }
`
export const StyledImage = styled.img`
  width: 100%;
  max-height: 250px;
  ${({ theme }) => theme.mediaQueries.md} {
    max-height: 400px;
    width: 50%;
    flex-direction: row;
  }
`

export default AboutHuntToken
